import * as React from 'react';
import clsx from 'clsx';
import { Model, PageModel } from 'survey-core';
import { Box } from '@material-ui/core';

type Props = {
  survey: Model;
};

interface ExtendedPageModel extends PageModel {
  showCompleteButton?: boolean;
}

export const Navigation: React.FC<Props> = ({ survey }) => {
  const [pageNo, setPageNo] = React.useState(survey.currentPageNo);
  const currentPage = survey.visiblePages[pageNo] as ExtendedPageModel;

  survey.onCurrentPageChanged.add((_, options) => {
    setPageNo(options.newCurrentPage.visibleIndex);
  });

  const isLastPage = pageNo === survey.visiblePages.length - 1;
  const prevPage = () => survey.prevPage();
  const nextPage = () => survey.nextPage();
  const endSurvey = () => survey.completeLastPage();

  const renderButton = (text: string, func: () => void, canRender: boolean, key: string): JSX.Element | null => {
    if (!canRender) return null;
    return (
      <Box className="sv-action">
        <button className={`sd-btn sd-navigation__${key}-btn`} onClick={func} tabIndex={1}>
          {text}
        </button>
      </Box>
    );
  };

  return (
    <div className={clsx('sd-action-bar', isLastPage && 'sd-action-admin')}>
      <Box display="flex">
        {renderButton(survey.pagePrevText, prevPage, pageNo !== 0, 'prev')}
        {renderButton(survey.pageNextText, nextPage, !isLastPage, 'next')}
      </Box>
      {renderButton(
        survey.completeText,
        endSurvey,
        isLastPage && currentPage?.showCompleteButton !== false,
        'complete'
      )}
    </div>
  );
};
